<template>
  <w-flex justify-center align-center v-if="$zutil.role('Pentadbir Sistem')">
    <div class="w-card__content content-hardcode">
      <w-flex class="mt3">
        <div class="xs11 text-right" >
          <inertia-link :href="$route('baka.form',0)+'?premis_id='+data.id" class="w-button green--bg  w-button--dark size--md  ml1"> 
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
          </inertia-link>
        </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Ternakan</th>
          <th class="w-table__header  text-left">Baka</th>
          <th class="w-table__header  text-left">Generasi</th>
          <th class="w-table__header  text-left">Kod</th>
          <th class="w-table__header  text-left">Nama</th>
          <th class="w-table__header  text-left">Jantina</th>
          <th class="w-table__header  text-left">Kepemilikan</th>
          <th class="w-table__header  text-left">Berat Badan (Kg)</th>
          <th class="w-table__header  text-left">Status</th>
          <th class="w-table__header  text-left"  width="1%">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >{{dt.ternakan}}</td>
            <td class="w-table__cell text-left" >{{dt.baka}}</td>
            <td class="w-table__cell text-left" >{{dt.gred}}</td>
            <td class="w-table__cell text-left" >{{dt.kode}}</td>
            <td class="w-table__cell text-left" >{{dt.nama}}</td>
            <td class="w-table__cell text-left" >{{dt.jantina}}</td>
            <td class="w-table__cell text-left" >{{dt.kepemilikan}}</td>
            <td class="w-table__cell text-left" >{{dt.berat_badan}}</td>
            <td class="w-table__cell text-left" >{{dt.status}}</td>
            <td class="w-table__cell text-left" >
              <inertia-link :href="$route('baka.show',dt.id)" class="w-button w-button--dark size--md info-dark1--bg"> 
                <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
              </inertia-link>
            </td>
            
          </tr>
        </template>
      </tbody>
    </table>
  </div>


</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [],
      
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'premis/baka/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },
    
  },
      
  mounted() {
    this.getData()
    
  }
}
      

</script>  
